"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigationKeys = exports.arrowKeys = void 0;
exports.arrowKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
exports.navigationKeys = ["Tab", ...exports.arrowKeys];
